export enum CollectionItemBuiltInType {
  Favourites = 'favourites',
  Archive = 'archive',
}
